module.exports = __webpack_public_path__ + "static/battle06-4a9c6d12b52572fb493de79eee93e151.png";